module.exports = __webpack_public_path__ + "static/media/2 3 Ordkjedetest-Feil-los-tupp-meg-sa-norming.072e27e1.mp3";